import { useDashboard } from '@/hooks/useDashboard';
import KPICards from '@/components/KPICards';
import ChartCard from '@/components/charts/ChartCard';

export default function Overview() {
  const { tabData, loading, error, currentTab } = useDashboard();
  const data = tabData[currentTab];

  if (loading) return <div className="loading">加载中...</div>;
  if (error) return <div className="error">加载失败：{error}</div>;
  if (!data) return <div className="empty">暂无数据</div>;

  const chartKeys = Object.keys(data.charts || {});

  return (
    <div className="container">
      <KPICards kpi={data.kpi} />

      {chartKeys.length > 0 && (
        <div className="section">
          <div className="section-title">趋势 / 结构 / 排名</div>
          <div className="chart-row">
            {chartKeys.map((key) => {
              const chart = data.charts![key];
              const isFull = key === 'customer_trend' || key === 'coverage' || key === 'quality' || key === 'rank';
              return <ChartCard key={key} chartKey={key} chart={chart} fullWidth={isFull} />;
            })}
          </div>
        </div>
      )}
    </div>
  );
}
